console.log("[custom-events] loaded", new Date().toISOString())

window.Shopify = window.Shopify || {}

const MOBILE_BREAKPOINT = 749
window.__isMobileCart = () =>
  window.matchMedia(`(max-width:${MOBILE_BREAKPOINT}px)`).matches

const ON_CART_PAGE =
  location.pathname === "/cart" || location.pathname === "/cart/"

/* ─────────────────────────────────────────
   Mobile cart drawer → redirect to cart
───────────────────────────────────────── */
;(() => {
  if (ON_CART_PAGE) return

  const cartUrl = ((window.Shopify?.routes?.root) || "/") + "cart"

  function overrideDrawerOpen() {
    if (!window.__isMobileCart()) return

    const enabled = document.querySelector(
      'cart-drawer-component[data-mobile-drawer-enabled]'
    )
    if (enabled) return

    document
      .querySelectorAll('cart-drawer-component.cart-drawer')
      .forEach((comp) => {
        comp.open = () => window.location.assign(cartUrl)

        const dlg = comp.querySelector('dialog.cart-drawer__dialog')
        if (dlg) {
          try {
            if (dlg.open) dlg.close()
          } catch (_) {}
          dlg.removeAttribute('open')
        }

        comp.removeAttribute('auto-open')
      })
  }

  overrideDrawerOpen()
  window.addEventListener('resize', overrideDrawerOpen)
  document.addEventListener('shopify:section:load', overrideDrawerOpen)
})()

/* ─────────────────────────────────────────
   Block drawer open on mobile
───────────────────────────────────────── */
;(() => {
  if (ON_CART_PAGE) return

  const isMobile = () => window.__isMobileCart()

  function closeDrawer() {
    if (!isMobile()) return
    document
      .querySelectorAll(
        'cart-drawer-component.cart-drawer dialog.cart-drawer__dialog'
      )
      .forEach((dlg) => {
        try {
          dlg.close()
        } catch (_) {}
        dlg.removeAttribute('open')
      })
  }

  function blockOpen() {
    if (!isMobile()) return

    document
      .querySelectorAll(
        'cart-drawer-component.cart-drawer dialog.cart-drawer__dialog'
      )
      .forEach((dlg) => {
        if (dlg.__blocked) return
        dlg.__blocked = true

        if (dlg.showModal) dlg.showModal = () => {}

        const _set = dlg.setAttribute.bind(dlg)
        dlg.setAttribute = (k, v) => (k === "open" ? null : _set(k, v))
      })
  }

  blockOpen()
  closeDrawer()

  document.addEventListener('cart:update', closeDrawer)
  document.addEventListener('cart:updated', closeDrawer)

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('[name="add"], .quick-add, form[action*="/cart/add"]')
    ) {
      setTimeout(closeDrawer, 0)
    }
  })

  window.addEventListener('resize', () => {
    blockOpen()
    closeDrawer()
  })

  document.addEventListener('shopify:section:load', () => {
    blockOpen()
    closeDrawer()
  })
})()

/* ─────────────────────────────────────────
   Calendar → close gift accordion
───────────────────────────────────────── */
document.addEventListener('click', (e) => {
  const calendar = document.querySelector('#cc-calendar-overall')
  const giftAccordion = document.querySelector('.cart-note details')
  if (!calendar || !giftAccordion) return

  if (calendar.contains(e.target)) {
    giftAccordion.removeAttribute('open')
  }
})

document.addEventListener('focusin', (e) => {
  const calendar = document.querySelector('#cc-calendar-overall')
  const giftAccordion = document.querySelector('.cart-note details')
  if (!calendar || !giftAccordion) return

  if (calendar.contains(e.target)) {
    giftAccordion.removeAttribute('open')
  }
})

/* ─────────────────────────────────────────
   Add sitemap link to footer popover
───────────────────────────────────────── */
;(() => {
  function addSitemapToPopover() {
    const popover = document.querySelector(
      'anchored-popover-component .terms-policies-popover'
    )
    if (!popover) return

    const list = popover.querySelector('ul.policy_list')
    if (!list || list.querySelector('[data-sitemap-link]')) return

    const li = document.createElement('li')
    const a = document.createElement('a')
    a.href = '/pages/site-map'
    a.className = 'footer-utilities__text'
    a.textContent = 'Sitemap'
    a.dataset.sitemapLink = 'true'

    li.appendChild(a)
    list.appendChild(li)
  }

  document.addEventListener('DOMContentLoaded', addSitemapToPopover)
  document.addEventListener('shopify:section:load', addSitemapToPopover)
})()

/* ─────────────────────────────────────────
   Disable calendar dates (weekend cutoff)
───────────────────────────────────────── */
;(() => {
  const TZ = 'Europe/London'

  const fmt = (now, opt) =>
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...opt }).format(now)

  const iso = (now) =>
    new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(now)

  function targetIsos() {
    const now = new Date()
    const weekday = fmt(now, { weekday: 'short' })
    const hour = parseInt(fmt(now, { hour: '2-digit', hour12: false }), 10)
    const todayIso = iso(now)

    const addDays = (isoStr, days) => {
      const d = new Date(isoStr + 'T00:00:00Z')
      d.setUTCDate(d.getUTCDate() + days)
      return d.toISOString().slice(0, 10)
    }

    if (weekday === 'Sat' && hour >= 13)
      return [addDays(todayIso, 1), addDays(todayIso, 2)]

    if (weekday === 'Sun')
      return [todayIso, addDays(todayIso, 1)]

    return []
  }

  function apply(root = document) {
    const dates = targetIsos()
    if (!dates.length) return

    const table = root.querySelector('#cc-calendar-table')
    if (!table) return

    dates.forEach((d) => {
      table
        .querySelectorAll(`td[area-label="${d}"], td[aria-label="${d}"]`)
        .forEach((td) => {
          td.classList.remove('is-abled')
          td.classList.add('is-disabled')
          td.setAttribute('aria-disabled', 'true')
          td.tabIndex = -1
          td.style.pointerEvents = 'none'
          td.style.opacity = '0.45'
          td.style.cursor = 'not-allowed'
        })
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true })
  } else {
    apply()
  }

  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (
          n.nodeType === 1 &&
          (n.id === 'cc-calendar' ||
            n.querySelector?.('#cc-calendar-table'))
        ) {
          apply(n)
        }
      }
    }
  })

  mo.observe(document.documentElement, { childList: true, subtree: true })

  document.addEventListener('click', (e) => {
    if (
      e.target?.id === 'cc-next-button' ||
      e.target?.id === 'cc-back-button' ||
      e.target?.closest?.('#cc-next-button') ||
      e.target?.closest?.('#cc-back-button') ||
      e.target?.id === 'cc-calendar' ||
      e.target?.closest?.('#cc-calendar')
    ) {
      setTimeout(apply, 0)
    }
  })

  document.addEventListener('shopify:section:load', (e) => apply(e.target))
})()



/* ─────────────────────────────────────────
   Hide out-of-stock product cards
───────────────────────────────────────── */
;(() => {
  const hideOOS = (root = document) => {
    root.querySelectorAll('[data-oos-product-id]').forEach((m) => {
      const id = m.getAttribute('data-oos-product-id')
      const card =
        m.closest(`.product-grid__item[data-product-id="${id}"]`) ||
        m.closest('.product-grid__item')

      card?.style.setProperty('display', 'none', 'important')
    })
  }

  hideOOS()

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) hideOOS(n)
      })
    }
  }).observe(document.body, { childList: true, subtree: true })
})()

/* ─────────────────────────────────────────
   End scripts success
───────────────────────────────────────── */
console.log("[custom-events] completed", new Date().toISOString())

window.Shopify = window.Shopify || {}